import { object } from 'yup'
import { MultiStepSchema, StepSchema } from '../Types'
import { ImageAndBackgroundSchema, ImageSelectionSchema, meta } from './Common'
import { sourceVisualElementId } from '../shared/sourceVisualElementId'
import { designContent } from '../shared/designContent'
import { filename } from '../shared/filename'
import { designProject } from '../shared/designProject'

export const TemplateSchema = object({
  source_visual_element_id: sourceVisualElementId.required(),
  content: designContent,
  filename: filename,
  project: designProject,
}).meta({
  title: 'Refine Details',
  header: 'Refine details',
  submitLabel: 'Generate Post',
}) as StepSchema

export const FlowBSchema = {
  meta,
  steps: [ImageSelectionSchema, ImageAndBackgroundSchema.meta({ submitLabel: 'Refine Details' }), TemplateSchema],
} as MultiStepSchema
